import { render, staticRenderFns } from "./Peps.vue?vue&type=template&id=77efe22f&scoped=true"
import script from "./Peps.vue?vue&type=script&lang=js"
export * from "./Peps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77efe22f",
  null
  
)

export default component.exports